<template>
  <div id="UploadBox">
    <h2>Files Uploader</h2>
    <button
      type="button"
      id="DownLoadButton"
      class=""
      v-on:click="DownloadFile()"
    >
      Download
    </button>
    <span id="UploadArea">
      <label for="FileBox">Choose A File: </label
      ><input type="file" id="FileBox" v-on:change="FileChosen($event)" /><br />
      <label for="NameBox">Name: </label
      ><input type="text" id="NameBox" /><br />
      <button
        type="button"
        id="UploadButton"
        class="Button"
        v-on:click="StartUpload()"
      >
        Upload
      </button>
    </span>
  </div>
</template>
<script>
import axios from "axios";
import config from "@/router/globalConfig";
export default {
  name: "UploadTest",
  components: {},
  data() {
    return {
      SelectedFile: null,
      FReader: null,
      Name: null,
      UploadSize: 0,
      Files: [],
    };
  },
  mounted() {
    this.Ready();
  },
  methods: {
    Ready() {
      if (window.File && window.FileReader) {
        //These are the necessary HTML5 objects the we are going to use
        // document
        //   .getElementById("UploadButton")
        //   .addEventListener("click", this.StartUpload());
        // document
        //   .getElementById("FileBox")
        //   .addEventListener("change", this.FileChosen());
      } else {
        document.getElementById("UploadArea").innerHTML =
          "Your Browser Doesn't Support The File API Please Update Your Browser";
      }
    },
    FileChosen(evnt) {
      this.SelectedFile = evnt.target.files[0];
      document.getElementById("NameBox").value = this.SelectedFile.name;
    },
    StartUpload() {
      var me = this;
      if (document.getElementById("FileBox").value != "") {
        this.FReader = new FileReader();
        this.Name = document.getElementById("NameBox").value;
        var Content =
          "<span id='NameArea'>Uploading " +
          this.SelectedFile.name +
          " as " +
          this.Name +
          "</span>";
        Content +=
          '<div id="ProgressContainer"><div id="ProgressBar"></div></div><span id="percent">50%</span>';
        Content +=
          "<span id='Uploaded'> - <span id='MB'>0</span>/" +
          Math.round(this.SelectedFile.size / 1048576) +
          "MB</span>";
        document.getElementById("UploadArea").innerHTML = Content;
        var Place = 0;
        var Percent = 0;
        this.Files[this.Name] = {
          //Create a new Entry in The Files Variable
          FileSize: this.SelectedFile.size,
          FileName: this.Name,
          Data: "",
          IsRetry: false,
          IsAppend: false,
          Downloaded: 0,
        };
        this.FReader.onload = function (evnt) {
          //socket.emit('Upload', { 'Name' : Name, Data : evnt.target.result });
          var formData = new FormData();
          formData.append("fileInfo", JSON.stringify(me.Files[me.Name]));
          formData.append("file", evnt.target.result);

          axios
            .post(config.WEB_API_PATH + "FileDrive/UploadFiles", formData, {
              headers: {
                __RequestVerificationToken: config.AF_Token,
                Authorization: config.LOG_Token,
              },
              onUploadProgress: function (progressEvent) {}.bind(me),
              crossdomain: true,
            })
            .then(
              (response) => {
                console.log(response);
                //this.Files[this.Name]['Downloaded'] += data['Data'].length;
                me.Files[me.Name]["Downloaded"] += response.data;
                if (
                  me.Files[me.Name]["Downloaded"] <
                  me.Files[me.Name]["FileSize"]
                ) {
                  //If File is Fully Uploaded
                  me.Files[me.Name]["Data"] = ""; //Reset The Buffer
                  Place = me.Files[me.Name]["Downloaded"] / 524288;
                  Percent =
                    (me.Files[me.Name]["Downloaded"] /
                      me.Files[me.Name]["FileSize"]) *
                    100;
                  me.Files[me.Name]["IsRetry"] = false;
                  me.Files[me.Name]["IsAppend"] = true;
                  me.SynchData({ Place: Place, Percent: Percent });
                }
                if (
                  me.Files[me.Name]["Downloaded"] ==
                  me.Files[me.Name]["FileSize"]
                ) {
                  me.UpdateBar(100);
                }
              },
              (error) => {
                //console.log(error.response);
                /*
                if (error.response == undefined) {
                  alert("Error:" + error);
                } else {
                  if (error.response.status == "415") {
                    alert("Error: " + error.response.statusText);
                  } else {
                    if (error.response.data.message == undefined) {
                      alert("Error: " + error.response.data);
                    } else {
                      alert("Error: " + error.response.data.message);
                    }
                  }
                }*/
                me.Files[me.Name]["IsRetry"] = true;
                me.SynchData({ Place: Place, Percent: Percent });
              },
              (failure) => {
                alert("Failure: " + failure);
              }
            );
        };
        this.SynchData({ Place: 0, Percent: 0 });
      } else {
        alert("Please Select A File");
      }
    },
    SynchData(data) {
      this.UpdateBar(data["Percent"]);
      var Place = data["Place"] * 524288; //The Next Blocks Starting Position
      var NewFile; //The Variable that will hold the new Block of Data
      if (this.SelectedFile.webkitSlice)
        NewFile = this.SelectedFile.slice(
          Place,
          Place + Math.min(524288, this.SelectedFile.size - Place)
        );
      else
        NewFile = this.SelectedFile.slice(
          Place,
          Place + Math.min(524288, this.SelectedFile.size - Place)
        );
      this.UploadSize = NewFile.size;
      this.FReader.readAsDataURL(NewFile);
    },
    UpdateBar(percent) {
      document.getElementById("ProgressBar").style.width = percent + "%";
      document.getElementById("percent").innerHTML =
        Math.round(percent * 100) / 100 + "%";
      var MBDone = Math.round(
        ((percent / 100.0) * this.SelectedFile.size) / 1048576
      );
      document.getElementById("MB").innerHTML = MBDone;
    },
    DownloadFile() {
      const downloadUrl = (config.WEB_API_PATH + "FileDrive/DownloadFiles?fileID=-1");
            const link = document.createElement("a");
            link.href = downloadUrl;
            link.setAttribute("download", "file.zip"); //any other extension
            document.body.appendChild(link);
            link.click();
            link.remove();
      // const _data_ = { fileID: -1 };
      // axios
      //   .get(config.WEB_API_PATH + "Download/DownloadFiles", {
      //     headers: {
      //       __RequestVerificationToken: config.AF_Token,
      //       Authorization: config.LOG_Token,
      //     },
      //     params: _data_,
      //     crossdomain: true,
      //     responseType: 'blob',
      //   })
      //   .then(
      //     (response) => {
      //       const downloadUrl = window.URL.createObjectURL(new Blob([response.data]));
      //       const link = document.createElement("a");
      //       link.href = downloadUrl;
      //       link.setAttribute("download", "file.zip"); //any other extension
      //       document.body.appendChild(link);
      //       link.click();
      //       link.remove();
      //     },
      //     (error) => {}
      //   );
    },
  },
};
</script>
<style scoped>
h2 {
  font-size: 40px;
  margin-top: 6px;
  margin-bottom: 10px;
}

#Thumb {
  max-width: 230px;
  max-height: 130px;
}

#ProgressContainer {
  width: 396px;
  height: 36px;
  background: #f8f8f8;
  margin-top: 14px;
  border: 1px solid #e8e8e8;
  border-top: 1px solid #d8d8d8;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
  padding: 2px;
}

#ProgressBar {
  height: 100%;
  width: 0%;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
  background: -webkit-gradient(
    linear,
    left top,
    left bottom,
    from(#a50aad),
    color-stop(0.5, #6b0d6b),
    to(#4a074a)
  );
}

#UploadBox {
  background: #537936;
  padding: 20px;
  position: absolute;
  top: 50%;
  left: 45%;
  margin-left: -200px;
  margin-top: -150px;
  height: 200px;
  width: 600px;
  border: 1px solid #dfdfdf;

  -webkit-box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.2);
  -moz-box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.2);
  box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.2);

  -webkit-border-radius: 11px;
  -moz-border-radius: 11px;
  border-radius: 11px;
}

button.Button {
  font-size: 18px;
  color: #ffffff;
  padding: 8px 30px;
  background: -webkit-gradient(
    linear,
    left top,
    left bottom,
    from(#a50aad),
    color-stop(0.5, #6b0d6b),
    to(#4a074a)
  );

  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
  border: 1px solid #5b139e;

  -webkit-box-shadow: 0px 1px 3px rgba(000, 000, 000, 0.5),
    inset 0px 0px 3px rgba(255, 255, 255, 0.4);
  -moz-box-shadow: 0px 1px 3px rgba(000, 000, 000, 0.5),
    inset 0px 0px 3px rgba(255, 255, 255, 0.4);
  box-shadow: 0px 1px 3px rgba(000, 000, 000, 0.5),
    inset 0px 0px 3px rgba(255, 255, 255, 0.4);
  text-shadow: 0px -1px 0px rgba(000, 000, 000, 0.1),
    0px 1px 0px rgba(145, 035, 145, 1);
  position: absolute;
  bottom: 20px;
  right: 20px;
  cursor: pointer;
}

button.Button:hover {
  background: -webkit-gradient(
    linear,
    left top,
    left bottom,
    from(#a50aad),
    color-stop(0.8, #6b0d6b),
    to(#a50aad)
  );
  color: #d3d3d3;
}

button.Button:active {
  background: -webkit-gradient(
    linear,
    left top,
    left bottom,
    from(#4a074a),
    color-stop(0.8, #6b0d6b),
    to(#a50aad)
  );
}

input {
  margin-top: 10px;
  margin-bottom: 8px;
}

input[type="text"] {
  border: 1px solid #cdcdcd;
  border-top: 1px solid #676767;

  -webkit-border-radius: 3px;
  -moz-border-radius: 3px;
  border-radius: 3px;
  font-size: 18px;
  padding: 2px;
  width: 300px;
  margin-left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/UploadTest.vue